import { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { api } from "@/lib/api";

const ORIGIN = typeof window !== "undefined" ? window.location.origin : "";

/** Fetches title/meta/canonical/JSON-LD for the path from the backend (same source as crawler prerender). */
export function Seo({ path, fallbackTitle, noindex = false }) {
  const [m, setM] = useState(null);
  useEffect(() => {
    let live = true;
    if (noindex) return;
    api.get("/seo/meta", { params: { path } }).then((r) => live && setM(r.data)).catch(() => {});
    return () => { live = false; };
  }, [path, noindex]);
  const canonical = m?.canonical || ORIGIN + path;
  const title = m?.title || fallbackTitle || "Jorvik Tuning";
  return (
    <Helmet>
      <title>{title}</title>
      {m?.description && <meta name="description" content={m.description} />}
      <meta name="robots" content={noindex || m?.found === false ? "noindex" : "index,follow"} />
      {!noindex && <link rel="canonical" href={canonical} />}
      <meta property="og:title" content={title} />
      {m?.description && <meta property="og:description" content={m.description} />}
      <meta property="og:type" content={m?.type || "website"} />
      <meta property="og:url" content={canonical} />
      {m?.image && <meta property="og:image" content={m.image} />}
      {(m?.jsonld || []).map((j, i) => (
        <script key={i} type="application/ld+json">{JSON.stringify(j)}</script>
      ))}
    </Helmet>
  );
}
